import { Interval } from 'luxon';

import { EntityType } from 'common/types';

import { RefundReason, RefundsOverviewInsight } from './types';
import merchantGatewayApi from '../../api';
import { getBaseUrl, getDateRangeForApiCall } from '../utils';

export const getRefundsOverviewInsightForEntity = ({
  entityType,
  entityId,
  interval,
  refundReasons,
}: {
  entityType: EntityType;
  entityId: string;
  interval: Interval;
  refundReasons: RefundReason[];
}) => {
  return merchantGatewayApi
    .get<RefundsOverviewInsight>(`${getBaseUrl(entityType, entityId)}/refunds-overview`, {
      params: {
        ...getDateRangeForApiCall(interval),
        reasons: refundReasons.map(reason => reason.toLowerCase()).join(','),
      },
    })
    .then(response => response.data);
};
